import styled from 'styled-components'

import { Skeleton } from '@root/shared/ui-kit'

export const PhishingCheckBlockSkeleton = () => (
  <SkeletonRoot>
    <SkeletonHeaderRow>
      <Skeleton variant="circular" width={9} height={9} />
    </SkeletonHeaderRow>
    <SkeletonBody>
      <Skeleton.Line width="55%" />
      <Skeleton.Line width="70%" />
    </SkeletonBody>
  </SkeletonRoot>
)

const SkeletonRoot = styled.div`
  border-radius: 10px;
  background: var(--appearanceA-5, var(--appearanceA-5));
  padding: 10px;
  position: relative;
  min-height: 88px;
`

const SkeletonHeaderRow = styled.div`
  display: flex;
  justify-content: flex-end;
`

const SkeletonBody = styled.div`
  margin-top: 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;
`
